// extracted by mini-css-extract-plugin
module.exports = {"req":"AppRequirements_req__d74PD","req__plan":"AppRequirements_req__plan__HN2Fq","req__item":"AppRequirements_req__item__vL5cu"};